import React from "react";
import { Row, Col } from "react-bootstrap";
import PaginationNav from "./PaginationNav";
import { useSelector } from "react-redux";
import { selectQueryParams } from "../ui/customerListingReducer";

const TabularListingFooter = (props) => {
  const queryParams = useSelector(selectQueryParams);

  const onPerPageChange = (e) => {
    e.preventDefault();
    if (e.target.value !== "") {
      props.onPerPageChange(e, parseInt(e.target.value));
    }
  };

  const onPageChange = (e) => {
    e.preventDefault();
    if (e.target.value !== "") {
      props.onPageChange(e, parseInt(e.target.value));
    }
  };
  return (
    <div className="tabular-listing-header">
      <Row className="pb-2 pt-2">
        <Col lg={{ span: 7 }}>
          <div className="d-flex">
            <select
              value={queryParams.per_page}
              className="form-select me-2"
              onChange={onPerPageChange}
            >
              <option>5</option>
              <option>10</option>
              <option>25</option>
              <option>50</option>
              <option>100</option>
              <option>200</option>
              <option>500</option>
            </select>
            <input
              className="form-control me-3 goto-page"
              style={{ width: "50px", height: "35px" }}
              onChange={onPageChange}
            />
            <PaginationNav
              paginationMeta={props.paginationMeta}
              onPageChange={props.onPageChange}
            />
          </div>
        </Col>
      </Row>
    </div>
  );
};

export default TabularListingFooter;
